var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_10229)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27.75,
    transform: "translate(0.479492 0.601562)",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9395 14.7917C26.9395 13.8078 26.8536 12.8618 26.694 11.9536H13.9795V17.3207H21.2449C20.932 19.0551 19.9809 20.5246 18.5511 21.5084V24.9898H22.914C25.4668 22.5743 26.9395 19.0173 26.9395 14.7917Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9796 28.3515C17.6246 28.3515 20.6805 27.1091 22.9142 24.99L18.5512 21.5086C17.3423 22.3411 15.796 22.8331 13.9796 22.8331C10.4635 22.8331 7.48735 20.3923 6.42575 17.1128H1.91553V20.7077C4.13689 25.2423 8.70234 28.3515 13.9796 28.3515Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42563 17.113C6.15563 16.2805 6.00222 15.3912 6.00222 14.4767C6.00222 13.5623 6.15563 12.673 6.42563 11.8405V8.24561H1.9154C1.00108 10.1187 0.479492 12.2378 0.479492 14.4767C0.479492 16.7157 1.00108 18.8348 1.9154 20.7079L6.42563 17.113Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9796 6.12003C15.9617 6.12003 17.7412 6.82009 19.1403 8.19497L23.0123 4.21537C20.6744 1.97645 17.6185 0.601562 13.9796 0.601562C8.70234 0.601562 4.13689 3.71082 1.91553 8.24543L6.42575 11.8403C7.48734 8.56077 10.4635 6.12003 13.9796 6.12003Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_10229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27.75,
    fill: "white",
    transform: "translate(0.479492 0.601562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoIcon);
export default __webpack_public_path__ + "static/media/google-logo-icon.6e6cc991a03956d4ab4c6d1abbcce62f.svg";
export { ForwardRef as ReactComponent };